//注入按钮
import "./sysButton";
// import { DsfTest } from "./test";

//全局样式
import "./../assets/styles/pc/dsfStyle.scss";
// 引用工具
import * as utils from "./../assets/utils";
Vue.prototype.utils = utils;

import * as componentsCtrl from "./components";

import Vue2OrgTree from "vue2-org-tree";

utils.directiveResize(Vue);
Vue.use(Vue2OrgTree);


if(dsf.config?.setting_public_tingyun_init && dsf.config.setting_public_tingyun_init.token) {
  Promise.all([import(/* webpackChunkName: "tingyun-sdk-web" */ "@tingyun-sdk/web"), import(/* webpackChunkName: "tingyun-sdk-web" */ "@tingyun-sdk/web-plugin-record")]).then(([modules,record]) => {
    let initConfig = Object.assign(dsf.config.setting_public_tingyun_init,{page:{fpThreshold:3000},replay: {enabled:true,sampleRate:1.0 },plugins:[record.default()]})
    modules.default.init(initConfig) 
  })
}

const components = {
  ...componentsCtrl,
  // DsfTest
};
// const install = dsf.createDsfVueInstall("statistics-cloud", components);

function install(Vue) {
  for (let key in components) {
    let it = components[key];
    let name = dsf.isFunction(it) ? it.ctrlName || key : it.name;
    Vue.component(name, it);
    if (!window.$components["statisCloud"]) {
      window.$components["statisCloud"] = {};
    }
    window.$components["statisCloud"][name] = it;
  }
}

export default install;

export { install };
